import React, { ComponentProps } from 'react';

import {
  Control,
  DropdownMenu,
  DropdownTemplate,
  GenericItem,
} from '@adsk/alloy-react-dropdown';
import { StylableComponent } from '@adsk/alloy-react-theme';

export type ScheduleDropdownProps<TItem extends GenericItem> = ComponentProps<
  typeof DropdownTemplate
> &
  Omit<StylableComponent<HTMLDivElement>, 'onChange' | 'children'> & {
    onChange: (val: TItem) => void;
  };

const emptyRender = () => null;

const renderDropdownMenuWithoutFooter = (
  menuProps: ComponentProps<typeof DropdownMenu>,
) => <DropdownMenu renderFooter={emptyRender} {...menuProps} />;

const ScheduleDropdown = <TItem extends GenericItem>({
  className,
  onChange,
  ...props
}: ScheduleDropdownProps<TItem>) => {
  return (
    <DropdownTemplate
      renderControl={(controlProps) => (
        <Control className={className} {...controlProps} />
      )}
      renderMenu={renderDropdownMenuWithoutFooter}
      onSelectedItemChange={(changes) => {
        if (changes.selectedItem) {
          onChange(changes.selectedItem as TItem);
        }
      }}
      {...props}
    />
  );
};

export default ScheduleDropdown;
